import request from "@src/utils/request";

export interface CovetrusLoba {
  uid: string;
  name: string;
  acbUid?: string;
  acbName?: string;
}

export interface CovetrusDeliveryMode {
  code: string;
  name: string;
  description?: string;
}

export interface SelectCovetrusLobaPayload {
  lobaUid: string;
  acbUid?: string;
  lobaName?: string;
  acbName?: string;
}

export function validateOAuthCode(code: string, state?: string | null) {
  const payload: { code: string; state?: string } = { code };
  if (state) {
    payload.state = state;
  }
  return request().post("/api/v1/validate-covetrus-oauth-code/").send(payload);
}

export function listLobas() {
  return request().get("/api/v1/covetrus/lobas/").send();
}

export function selectLoba(payload: SelectCovetrusLobaPayload) {
  return request().post("/api/v1/covetrus/select-loba/").send(payload);
}

export function getDeliveryModes() {
  return request().get("/api/v1/covetrus/delivery-modes/").send();
}
